// extracted by mini-css-extract-plugin
export default {"fr-view":"Finder_fr-view__rwV2c","chapters":"Finder_chapters__bBdxT","chapter":"Finder_chapter__1gltO","isDraggingOver":"Finder_isDraggingOver__uHXeV"};